import { createContext } from 'react';
import formatMessage from 'format-message';

const IntlContext = createContext(formatMessage);
export default IntlContext;
